import { render } from "./Post.vue?vue&type=template&id=6e402920&scoped=true"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"

import "./Post.vue?vue&type=style&index=0&id=6e402920&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e402920"

export default script